/* Built In Imports */
import NextLink from 'next/link';

/* External Imports */
import { Box, Link } from '@chakra-ui/react';

/* Internal Imports */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import { refineUrlDomain } from '@components/Utility/utils';

/* Services */

/**
 * Renders Weave Card component
 * @param {Object} card - card to render
 * @returns {ReactElement} Weave Card component
 */
const WeaveCard = ({ card, isLanding }) => {
  return (
    <NextLink passHref href={refineUrlDomain(card?.url)} legacyBehavior>
      <Link
        maxW="270px"
        bg="#fff"
        boxShadow="0 0 16px 0 rgb(0 0 0 / 15%)"
        _hover={{
          boxShadow: '0 0 65px 7px rgb(124, 124, 124, 0.75)',
        }}
      >
        <LazyLoadImageComponent
          src={card?.cardImage}
          alt={card?.title}
          title={card?.title}
          clipPath="polygon(0 0, 100% 0, 100% 100%, 0% 92%)"
          w="270px"
          minH="125px"
        />
        <Box px={4} py={5} fontFamily="FedraSansStd-A-medium">
          <Box as="h4">{card?.title}</Box>
          <Box
            as="p"
            fontFamily="FedraSansStd-book"
            className="truncate-text"
            pt={4}
            fontSize="14px"
            color="#676055"
          >
            {card?.summary}
          </Box>
        </Box>
      </Link>
    </NextLink>
  );
};

export default WeaveCard;
